import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';

import MaskLayerComponent from '../components/mask-layer/mask-layer.jsx';

import {
    closeMaskLayer
} from '../reducers/modals';

class MaskLayer extends React.Component {
    constructor (props) {
        super(props);
        this.handleClickInitMaskLayer = this.handleClickInitMaskLayer.bind(this);
    }

    componentDidMount () {
        document.addEventListener('click', this.handleClickInitMaskLayer);
    }

    componentWillUnmount () {
        document.removeEventListener('click', this.handleClickInitMaskLayer);
    }

    handleClickInitMaskLayer () {
        this.props.onMaskLayerInited();
        // jyj added，add a prompt for handing in homework first time
        window.localStorage.maskLayerInited = true;
    }

    render () {
        return (
            <MaskLayerComponent />
        );
    }
}

MaskLayer.propTypes = {
    onMaskLayerInited: PropTypes.func
};

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
    onMaskLayerInited: () => {
        dispatch(closeMaskLayer());
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MaskLayer);
